import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';

import {Toggle} from '@stubhub/bamboo';

import MESSAGES from '../../../messages';

import './CookieTabAccordionItem.scss';

export const CookieTabAccordionItem = ({
  id,
  name = '',
  isActive = false,
  isMandatory,
  handleActiveCookie,
  visiblity,
  handleTabAccordionItemVisiblity,
}) => {
  const [checked, setChecked] = useState(isActive[name]);

  const handleChange = (e) => {
    setChecked(e.target.checked);
    handleActiveCookie(name, e.target.checked);
  };

  return (
    <>
      <div className="CookieTabAccordionItem__title">
        <p
          className={classnames('CookieTabAccordionItem__titleText', {
            CookieTabAccordionItem__active: visiblity === id,
          })}
          onClick={() => handleTabAccordionItemVisiblity(id)}
        >
          <FormattedMessage {...MESSAGES[`${name.toUpperCase()}_TITLE`]} />
        </p>
      </div>
      <div className="CookieTabAccordionItem__description">
        {visiblity === id && (
          <div className="CookieTabAccordionItem__subtitleContainer">
            <strong>
              <FormattedMessage {...MESSAGES.IS_ACTIVE_MSG} />
            </strong>
            {isMandatory ? (
              <p className="CookieTabAccordionItem__isMandatory">
                <FormattedMessage {...MESSAGES.IS_MANDATORY_MSG} />
              </p>
            ) : (
              <Toggle
                id={`CookieTabAccordionItem__toogle_${id}`}
                checked={checked}
                onChange={handleChange}
                name={name}
              />
            )}
          </div>
        )}
        <p
          className={classnames('CookieTabAccordionItem__descriptionText', {
            CookieTabAccordionItem__descriptionTextActive: visiblity === id,
          })}
        >
          <FormattedMessage {...MESSAGES[`${name.toUpperCase()}_DESCRIPTION`]} />
        </p>
      </div>
    </>
  );
};

CookieTabAccordionItem.displayName = 'CookieAccordionItem';

CookieTabAccordionItem.propTypes = {
  /**  Unique identifier for the item */
  id: PropTypes.number.isRequired,

  /**  Name of the item, expected to be a string and is required */
  name: PropTypes.string.isRequired,

  /**  Indicates whether the item is active */
  isActive: PropTypes.object,

  /**  Boolean value indicating if the item is mandatory */
  isMandatory: PropTypes.bool.isRequired,

  /**  Function to handle the activation state of the cookie item */
  handleActiveCookie: PropTypes.func.isRequired,

  /**  Visibility of the item */
  visiblity: PropTypes.number.isRequired,

  /**  Function to handle the visibility of the tab or accordion item */
  handleTabAccordionItemVisiblity: PropTypes.func.isRequired,
};
